module.exports = __webpack_public_path__ + "assets/img/sig_cert_logo.2d39e4af.jpg";